import { useEffect, useState } from 'react'
import MagnifyingGlassIcon from '../icons/magnifyingglass'

export default function SearchSelect({ values, onSelect, isMultiSelect = false, multiSelectValues, onRemoveMultiSelectValue, disabled, defaultValue, placeholder = "Search..." }) {

    useEffect(() => {
        if (values && !disabled) setFilteredValues(values)
    }, [values])

    const [filteredValues, setFilteredValues] = useState(values || [])

    const [selectedValue, setSelectedValue] = useState(defaultValue)

    const onInputChange = (value) => {
        setFilteredValues(values?.filter(t => t.name.search(value) >= 0 && !multiSelectValues?.map(y => y.id).includes(t.id)) || [])
    }

    const handleElementClick = (item) => {
        const elem = document.activeElement;
        if (elem) {
            elem?.blur();
        }
        onSelect(item)
        if (!isMultiSelect) {
            setSelectedValue(item.name)
        }
    }

    useEffect(() => {
        onInputChange('')
    }, [multiSelectValues])

    return (
        <div>
            <div className='dropdown dropdown-bottom w-full'>
                <label tabIndex="0" className="input input-bordered flex items-center gap-2 w-full bg-white">
                    <MagnifyingGlassIcon className="size-5" />
                    <input type="text" placeholder={selectedValue && !isMultiSelect ? selectedValue : placeholder} className="grow" onInput={(e) => onInputChange(e.target.value)} disabled={disabled} />
                    <svg
                        className="w-5 h-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </label>
                {!disabled && <ul tabIndex="0" className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-full max-h-60 overflow-y-auto block bg-white text-black">
                    {
                        filteredValues.map(v => (
                            <li key={v.id}><a onClick={() => handleElementClick(v)}>{v.name}</a></li>
                        ))
                    }
                </ul>}
            </div>
            {
                isMultiSelect && <div className="flex flex-wrap gap-2 mt-4">
                    {multiSelectValues?.map(value => (
                        <div key={value.id} onClick={() => onRemoveMultiSelectValue(value.id)} className='badge bg-primary text-black gap-2 cursor-pointer'>
                            {value.name}
                        </div>
                    ))}
                </div>
            }
        </div>
    )
}